import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  declare readonly panelTarget: HTMLElement;

  private handleClickOutside: (event: MouseEvent) => void = () => {};

  connect() {
    this.handleClickOutside = this._handleClickOutside.bind(this);
  }

  isMobile() {
    return (
      /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      window.innerWidth <= 768
    );
  }

  toggle(event: MouseEvent) {
    event.stopPropagation();
    const isOpen = !this.panelTarget.classList.contains("invisible");
    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.panelTarget.classList.remove("invisible");
    document.addEventListener("click", this.handleClickOutside);

    if (this.isMobile()) {
      document.body.classList.add("overflow-hidden");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  close() {
    this.panelTarget.classList.add("invisible");
    document.removeEventListener("click", this.handleClickOutside);

    if (this.isMobile()) {
      document.body.classList.remove("overflow-hidden");
    }
  }

  private _handleClickOutside(event: MouseEvent) {
    if (!this.element.contains(event.target as Node)) {
      this.close();
    }
  }
}
